import styled from "styled-components";
import card from "./cardcredit.png";

const Img = styled.img`
  width: 328px;
  height: 160px;
  flex-grow: 0;
`;

export default () => <Img src={card} alt={"대상자만을 위한 최대 혜택"} />;
